export const buttonStyles = {
  backgroundColor: '#6656F9',
  color: '#FFF',
};

export const playerLocationBlocks =
  [
    {
      locationId: 16,
      description: ''
    },
    {
      locationId: 15,
      description: ''
    },
    {
      locationId: 12,
      description: ''
    },
    {
      locationId: 11,
      description: ''
    },
    {
      locationId: 14,
      description: ''
    },
    {
      locationId: 13,
      description: ''
    },
    {
      locationId: 10,
      description: ''
    },
    {
      locationId: 9,
      description: ''
    },
    {
      locationId: 8,
      description: ''
    },
    {
      locationId: 7,
      description: ''
    },
    {
      locationId: 4,
      description: ''
    },
    {
      locationId: 3,
      description: ''
    },
    {
      locationId: 6,
      description: ''
    },
    {
      locationId: 5,
      description: ''
    },
    {
      locationId: 2,
      description: ''
    },
    {
      locationId: 1,
      description: ''
    },
  ];

export const shotTypes = {
  topSpin: {
    id: 'TOP_SPIN',
    title: 'Top Spin',
  },
  slice: {
    id: 'SLICE',
    title: 'Slice',
  },
  lob: {
    id: 'LOB',
    title: 'Lob',
  }
};

export const spinLevels = {
  L1: {
    title: 'Low Spin',
  },
  L3: {
    title: 'Medium Spin',
  },
  L5: {
    title: 'High Spin',
  }
};

export const steps = ['Select Location Block', 'Shot Type', 'Spin Level'];
